import { ProfileActionTypes, } from './types';
import { createAsyncMapAction } from '~lib/shared/redux/actions';
export const profileById = createAsyncMapAction(ProfileActionTypes.PROFILE_BY_ID, p => [p.userId, p.revision].filter(Boolean).join('@'));
export const updateProfile = createAsyncMapAction(ProfileActionTypes.UPDATE_PROFILE, p => p.requestId);
export const listProfiles = createAsyncMapAction(ProfileActionTypes.LIST_PROFILES, p => p.requestId);
export const search = createAsyncMapAction(ProfileActionTypes.SEARCH, p => p.requestId);
